<template>
  <div>
    <datatable
      @create="createLocation"
      @delete="deleteLocation"
      title="Applicant Locations"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'applicant-locations',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'lat',
          value: 'lat'
        },
        {
          name: 'long',
          value: 'long'
        },
        {
          name: 'description',
          value: 'description'
        }
      ],
      data: [],
      operations: [],
      applicant_id: this.$route.query.applicant_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getResourceLocations({
          current_type: 'Applicant',
          current_resource_id: this.applicant_id
        })
        .then(response => {
          if (response == undefined || response[0] == undefined) {
            this.data = []
            return
          }
          this.data = Array.isArray(response) ? response : [response]
        })
    },
    deleteLocation (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.description,
        item_name: delete_data.description,
        method: 'deleteLocation',
        method_params: { id: delete_data.id, current_type: 'Applicant', current_resource_id: this.applicant_id }
      })
    },
    createLocation () {
      this.create({ designator: 'applicant-locations-form-modal', component_name: 'LocationsForm', is_create: true, resource_type: 'Applicant', resource_id: this.applicant_id, modal_title: 'Create new Location' })
    },
    editClick (data) {
      this.create({ designator: 'applicant-locations-form-modal', component_name: 'LocationsForm', data, resource_type: 'Applicant', resource_id: this.applicant_id, modal_title: data.description })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
